module.exports = __webpack_public_path__ + "img/status-promotion.9a1817c3.png";